import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl, { LngLatBoundsLike } from 'mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax

mapboxgl.accessToken =
  'pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJjaXNhNGFsdHAwMDB2Mm9wNWdlMTlqMTNuIn0.uj5aGvF3yvEM4V6kNdlbVg'

const isMobile = window.innerWidth < 711
const isLarge = window.innerWidth >= 1750
const isSmall = window.innerWidth < 340


export const Map = ({ showScroll, getMap }: { showScroll: boolean, getMap: (map: mapboxgl.Map) => void }) => {
  const mapContainer = useRef(null)
  const map = useRef<mapboxgl.Map>(null)
  const [mapLoaded, setMapLoaded] = useState(false)




  useEffect(() => {
    if (map.current) return // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/ta-interaktiv/cl16hsnrs001y14o6d75p8nfm',
      // style: 'mapbox://styles/ta-interaktiv/cl120jdqe000z14o4665fxjs4',
      center: [8.226667, 46.801111],
      zoom: isSmall ? 5.5 : isMobile ? 5.8 : isLarge ? 7.6 : 7.2,
      pitch: 0,
      interactive: false,
      renderWorldCopies: false,

    })

    map.current.on("load", () => {

      setMapLoaded(true)

    })
    if (getMap) {
      map.current.on('style.load', e => {
        if (map.current !== null) getMap(map.current)
      })
    }
  }, [])

  return (
    <div
      className='map-wrapper'
      style={{ height: '100vh' }}
    ><div ref={mapContainer} className='map-container' />
      {!mapLoaded && <div className='loader'>Karte wird geladen</div>}
      {showScroll && <div className='scrollarrow'>Weiter scrollen</div>}
    </div>
  )
}
